import { VIDEOTYPES } from '@/plugins/file-types';
export default {
  props: {
    liveUrl: String,
    // 直播地址
    playback: String,
    // 回放地址
    liveStatus: Number // 直播状态

  },

  data() {
    return {
      currentIndex: 0,
      // 当前回放视频索引
      player: null,
      // 播放器实例
      numList: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
      playbackList: [],
      currentPlaybackUrl: '',
      isVideo: true
    };
  },

  watch: {
    playback: {
      handler(value) {
        if (value && this.liveStatus > 1) {
          this.playbackList = value.split(',');
          const suffix = this.playbackList[0].split('.')[this.playbackList[0].split('.').length - 1].toLowerCase();

          if (VIDEOTYPES.includes(suffix)) {
            this.isVideo = true;
            this.$nextTick(() => {
              this.initPlay(this.playbackList[0]);
            });
          } else {
            this.isVideo = false;
            this.currentPlaybackUrl = this.playbackList[0];
          }
        }
      },

      immediate: true
    }
  },
  methods: {
    // 回放事件
    handlePlayback(item, index) {
      this.currentIndex = index;
      const suffix = item.split('.')[item.split('.').length - 1].toLowerCase();

      if (VIDEOTYPES.includes(suffix)) {
        this.isVideo = true;
        this.player.loadByUrl(item); // 加载播放地址
      } else {
        this.isVideo = false;
        this.currentPlaybackUrl = item;
      }
    },

    // 初始化播放器
    initPlay(url) {
      this.player = new Aliplayer({
        id: 'lecture-video',
        source: url,
        cover: '',
        width: '100%',
        height: '100%',
        autoplay: true,
        isLive: false,
        rePlay: false,
        playsinline: true,
        'p~reload': true,
        enableStashBufferForFlv: true,
        stashInitialSizeForFlv: 32,
        controlBarVisibility: 'hover',
        useH5Prism: true // "skinLayout":false,

      }, function (player) {
        console.log('The player is created', player);
      });
    }

  }
};